module.exports = __webpack_public_path__ + "img/virgin-radio.d47c79a2.png";